export const FIELDS = {

  ID: 'id',
  COMPANY_ID: 'companyId',
  PAYMENT_DATE: 'paymentDate',
  PAYMENT_METHOD_ID: 'paymentMethodId',
  REFERENCE_NUMBER: 'referenceNumber',
  DEPOSIT_TO_ID: 'depositToId',
  AMOUNT: 'amount',
  COMMENTS: 'comments',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  ACTIVE: 'active',
  COMPANY_NAME: 'companyName',
  PAYMENT_METHOD_NAME: 'paymentMethodName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};

export const INVOICE_FIELDS = {
  ID: 'id',
  INVOICE_NUMBER: 'invoiceNumber',
  INVOICE_DATE: 'invoiceDate',
  SALES_ORDER_ID: 'salesOrderId',
  STATUS_ID: 'statusId',
  COMPANY_ID: 'companyId',
  CONTACT_ID: 'contactId',
  SALES_PERSON_USER_ID: 'salesPersonUserId',
  CONTRACT_NUMBER: 'contractNumber',
  CUSTOMER_PO: 'customerPo',
  SALES_ORDER_NUMBER: 'salesOrderNumber',
  SHIP_TO: 'shipTo',
  BILL_TO: 'billTo',
  BILLING_TERM_ID: 'billingTermId',
  INCO_TERM_ID: 'incoTermId',
  DUE_DATE: 'dueDate',
  SHIP_DATE: 'shipDate',
  SHIPPING_METHOD_ID: 'shippingMethodId',
  TRACKING_NUMBER: 'trackingNumber',
  INTERNAL_COMMENTS: 'internalComments',
  COMMENTS: 'comments',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  EXCHANGE_RATE: 'exchangeRate',
  TAX_NUMBER: 'taxNumber',
  IS_TAXABLE: 'isTaxable',
  TAX_RATE: 'taxRate',
  SHIPPING_NO_CHARGE: 'shippingNoCharge',
  SHIPPING_CHARGE: 'shippingCharge',
  SUB_TOTAL: 'subTotal',
  TOTAL_LINE_COST: 'totalLineCost',
  TOTAL_CHARGES_TAXABLE: 'totalChargesTaxable',
  TOTAL_CHARGES_NON_TAXABLE: 'totalChargesNonTaxable',
  TOTAL_CHARGES: 'totalCharges',
  TOTAL_CHARGES_COST: 'totalChargesCost',
  TAX: 'tax',
  CREDIT_AMOUNT: 'creditAmount',
  TOTAL: 'total',
  SUB_TOTAL_CONVERTED: 'subTotalConverted',
  TOTAL_LINE_COST_CONVERTED: 'totalLineCostConverted',
  TOTAL_CHARGES_TAXABLE_CONVERTED: 'totalChargesTaxableConverted',
  TOTAL_CHARGES_NON_TAXABLE_CONVERTED: 'totalChargesNonTaxableConverted',
  TOTAL_CHARGES_CONVERTED: 'totalChargesConverted',
  TOTAL_CHARGES_COST_CONVERTED: 'totalChargesCostConverted',
  TOTAL_CONVERTED: 'totalConverted',
  GROSS_PROFIT: 'grossProfit',
  GPMARGIN: 'gpMargin',
  AMOUNT_PAID: 'amountPaid',
  BALANCE: 'balance',
  ATTENTION: 'attention',
  IS_AUTHORIZED: 'isAuthorized',
  AUTHORIZED_BY_USER_ID: 'authorizedByUserId',
  DATE_AUTHORIZED: 'dateAuthorized',
  QBTXN_ID: 'qbTxnId',
  QBSYNCED: 'qbSynced',
  ON_HOLD: 'onHold',
  IS_PROFORMA: 'isProforma',
  SHIP_ON_CUST_ACCOUNT: 'shipOnCustAccount',
  SHIPPED_BY_USER_ID: 'shippedByUserId',
  SHIPPING_NUMBER: 'shippingNumber',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  INVOICE_NO: 'invoiceNo',
  STATUS_NAME: 'statusName',
  COMPANY_NAME: 'companyName',
  CONTACT: 'contact',
  BILLING_TERM_NAME: 'billingTermName',
  INCO_TERM_NAME: 'incoTermName',
  SALES_PERSON_USER_FULL_NAME: 'salesPersonUserFullName',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  SHIPPING_METHOD_NAME: 'shippingMethodName',
  SHIPPED_BY_USER_FULL_NAME: 'shippedByUserFullName',
  EXPR1: 'expr1',
  AUTHORIZED_BY_USER_FULL_NAME: 'authorizedByUserFullName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};

export const CREDIT_FIELDS = {

  ID: 'id',
  CREDIT_DATE: 'dateCreated',
  SO_NO: 'salesOrderId',
  AMOUNT: 'amount',
  BALANCE: 'balance',
};
